/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export const GetClipzyGetOpServerList = [
  "https://paste.sdjz.wiki",
] as const;

export type GetClipzyGetRequest = { id: string };

export const GetClipzyGetRequest$zodSchema: z.ZodType<GetClipzyGetRequest> = z
  .object({
    id: z.string().describe("片段的唯一 ID。"),
  });

/**
 * 片段未找到。它可能已过期、被删除或ID不正确。
 */
export type GetClipzyGetNotFoundResponseBody = { error?: string | undefined };

export const GetClipzyGetNotFoundResponseBody$zodSchema: z.ZodType<
  GetClipzyGetNotFoundResponseBody
> = z.object({
  error: z.string().optional(),
}).describe("片段未找到。它可能已过期、被删除或ID不正确。");

/**
 * 请求参数错误，通常是缺少 `id` 参数。
 */
export type GetClipzyGetBadRequestResponseBody = { error?: string | undefined };

export const GetClipzyGetBadRequestResponseBody$zodSchema: z.ZodType<
  GetClipzyGetBadRequestResponseBody
> = z.object({
  error: z.string().optional(),
}).describe("请求参数错误，通常是缺少 `id` 参数。");

/**
 * 获取成功！返回加密并压缩后的数据。
 */
export type GetClipzyGetResponseBody = { compressedData?: string | undefined };

export const GetClipzyGetResponseBody$zodSchema: z.ZodType<
  GetClipzyGetResponseBody
> = z.object({
  compressedData: z.string().optional(),
}).describe("获取成功！返回加密并压缩后的数据。");

export type GetClipzyGetResponse =
  | GetClipzyGetResponseBody
  | GetClipzyGetBadRequestResponseBody
  | GetClipzyGetNotFoundResponseBody;

export const GetClipzyGetResponse$zodSchema: z.ZodType<GetClipzyGetResponse> = z
  .union([
    z.lazy(() => GetClipzyGetResponseBody$zodSchema),
    z.lazy(() => GetClipzyGetBadRequestResponseBody$zodSchema),
    z.lazy(() => GetClipzyGetNotFoundResponseBody$zodSchema),
  ]);
